import { params } from "../vars/params";

export const scroll = (): void => {
  let lastScrollY = window.scrollY;
  window.addEventListener("scroll", () => {
    params.scrolled = window.scrollY > params.bH * 0.8;
    if (params.scrolled) {
      document.body.classList.add("scrolled");
    } else {
      document.body.classList.remove("scrolled");
    }
    const currentScrollY = window.scrollY;
    if (currentScrollY > lastScrollY) {
      params.scrollDirection = "down";
    } else {
      params.scrollDirection = "up";
    }
    lastScrollY = currentScrollY;
  });
};
